var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevicename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7423 11.0422C10.749 11.0689 10.749 11.0952 10.749 11.1219V12.3785H1.5V11.1219C1.5 10.7005 1.75867 10.3192 2.15333 10.1635L4.793 9.11885C5.14133 8.98285 5.234 8.52185 4.95233 8.26985C4.435 7.80552 4.09667 7.04285 4.09667 6.18052C4.09667 4.76452 5.00533 3.61719 6.126 3.61719C7.24367 3.61719 8.15233 4.76452 8.15233 6.18052C8.15233 7.04285 7.814 7.80552 7.29667 8.26985C7.015 8.52185 7.10767 8.98285 7.456 9.11885L9.61467 9.97119V9.97452",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.637 4.81031C11.114 5.25131 10.625 5.52931 9.32137 5.78364C9.26193 5.7948 9.20825 5.82634 9.16955 5.87283C9.13086 5.91931 9.10958 5.97783 9.10938 6.03831V8.38431C9.10938 9.87197 10.4794 11.3413 11.803 11.3413C13.0834 11.3413 14.497 9.87197 14.497 8.38431V6.03831C14.4967 5.97784 14.4754 5.91936 14.4366 5.87294C14.3979 5.82652 14.3442 5.79506 14.2847 5.78397C12.9814 5.52931 12.4924 5.25131 11.9697 4.81031C11.923 4.77134 11.8641 4.75 11.8032 4.75C11.7424 4.75 11.6838 4.77134 11.637 4.81031Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3373 7.16406L11.4546 8.96006L10.6406 8.14573",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicename);
export default __webpack_public_path__ + "static/media/Devicename.f50087c9547d430c84b640a6305a4efb.svg";
export { ForwardRef as ReactComponent };